import type { ReorderStage } from './reorder-stage.js';
import { REORDER_STAGES } from './reorder-stages.js';

export function isReorderStage(value: unknown): value is ReorderStage {
  return typeof value === 'string' && (REORDER_STAGES as readonly string[]).includes(value);
}
